var map = {
	"./icon-arrow-diagonal.svg": 2968,
	"./icon-arrow-horizontal.svg": 2173,
	"./icon-arrow-vertical.svg": 3627,
	"./icon-balance.svg": 3691,
	"./icon-bitcoin.svg": 8389,
	"./icon-building.svg": 7909,
	"./icon-building2.svg": 8509,
	"./icon-building3.svg": 9036,
	"./icon-bullseye.svg": 6828,
	"./icon-calendar.svg": 6683,
	"./icon-car.svg": 9313,
	"./icon-cart.svg": 2063,
	"./icon-chart.svg": 3095,
	"./icon-chart2.svg": 4375,
	"./icon-chart3.svg": 7926,
	"./icon-click.svg": 6095,
	"./icon-click2.svg": 7823,
	"./icon-clock.svg": 6341,
	"./icon-cross.svg": 9323,
	"./icon-crosshair.svg": 6159,
	"./icon-cyber.svg": 4536,
	"./icon-device.svg": 2531,
	"./icon-dollar.svg": 3671,
	"./icon-drop.svg": 5766,
	"./icon-euro.svg": 1978,
	"./icon-globe.svg": 3560,
	"./icon-gold-bars.svg": 3490,
	"./icon-gold.svg": 9723,
	"./icon-group.svg": 4694,
	"./icon-home.svg": 2000,
	"./icon-idea.svg": 6240,
	"./icon-info.svg": 3029,
	"./icon-laptop.svg": 2205,
	"./icon-law.svg": 1827,
	"./icon-law2.svg": 4619,
	"./icon-leaf.svg": 757,
	"./icon-lightbulb.svg": 2998,
	"./icon-list.svg": 5657,
	"./icon-lock-solid.svg": 5514,
	"./icon-lock.svg": 8908,
	"./icon-logo.svg": 2996,
	"./icon-logout.svg": 9855,
	"./icon-mail.svg": 652,
	"./icon-money-bag.svg": 38,
	"./icon-money-drop.svg": 2779,
	"./icon-money.svg": 5803,
	"./icon-monitor.svg": 7713,
	"./icon-oil.svg": 8283,
	"./icon-piggy-bank.svg": 1322,
	"./icon-pin.svg": 694,
	"./icon-plane.svg": 3977,
	"./icon-play.svg": 355,
	"./icon-plus.svg": 9653,
	"./icon-point.svg": 8617,
	"./icon-pound.svg": 2845,
	"./icon-recycle.svg": 3852,
	"./icon-rock-cart.svg": 9821,
	"./icon-rock.svg": 5798,
	"./icon-ruler.svg": 5655,
	"./icon-search.svg": 1049,
	"./icon-signal.svg": 593,
	"./icon-sliders.svg": 9937,
	"./icon-speech.svg": 5511,
	"./icon-speedometer.svg": 4088,
	"./icon-star-empty.svg": 7529,
	"./icon-star-full.svg": 5869,
	"./icon-star-half.svg": 5377,
	"./icon-star.svg": 4957,
	"./icon-system-add.svg": 3348,
	"./icon-system-arrow-down-left.svg": 511,
	"./icon-system-arrow-down-right.svg": 3706,
	"./icon-system-arrow-down.svg": 4699,
	"./icon-system-arrow-left.svg": 1676,
	"./icon-system-arrow-right.svg": 7923,
	"./icon-system-arrow-up-left.svg": 4462,
	"./icon-system-arrow-up-right.svg": 3133,
	"./icon-system-arrow-up.svg": 8180,
	"./icon-system-benchmark.svg": 4604,
	"./icon-system-checkmark-filled.svg": 7835,
	"./icon-system-checkmark.svg": 6670,
	"./icon-system-chevron-down-large.svg": 1039,
	"./icon-system-chevron-down-small.svg": 9891,
	"./icon-system-chevron-left-large.svg": 9576,
	"./icon-system-chevron-left-small.svg": 1184,
	"./icon-system-chevron-right-large.svg": 9519,
	"./icon-system-chevron-right-small.svg": 4291,
	"./icon-system-chevron-up-large.svg": 8764,
	"./icon-system-chevron-up-small.svg": 8212,
	"./icon-system-close.svg": 7921,
	"./icon-system-copy.svg": 5524,
	"./icon-system-dot-menu-horizontal.svg": 9197,
	"./icon-system-dot-menu-vertical.svg": 2235,
	"./icon-system-edit.svg": 5035,
	"./icon-system-help-filled.svg": 5763,
	"./icon-system-help.svg": 278,
	"./icon-system-info.svg": 2399,
	"./icon-system-list.svg": 2683,
	"./icon-system-open-down.svg": 6936,
	"./icon-system-open-left.svg": 1479,
	"./icon-system-open-right.svg": 6002,
	"./icon-system-open-up.svg": 9083,
	"./icon-system-report.svg": 5881,
	"./icon-system-search.svg": 1187,
	"./icon-system-subtract-alt.svg": 5717,
	"./icon-system-subtract.svg": 4587,
	"./icon-system-trash.svg": 1007,
	"./icon-system-view-filled.svg": 6229,
	"./icon-system-view-off.svg": 9532,
	"./icon-system-warning-filled.svg": 5990,
	"./icon-system-warning.svg": 9389,
	"./icon-target.svg": 9106,
	"./icon-target2.svg": 3020,
	"./icon-thumbs-up.svg": 9676,
	"./icon-time.svg": 5126,
	"./icon-todo-list.svg": 7362,
	"./icon-tree.svg": 3037,
	"./icon-trophy.svg": 247,
	"./icon-upwards.svg": 9371,
	"./icon-user.svg": 1472,
	"./icon-users.svg": 5187,
	"./icon-warning.svg": 399,
	"./icon-wave.svg": 5998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;